import { Route, Routes } from "react-router-dom";
import Empty from '../components/Layout/Empty';
import MainLayout from "../components/Layout/MainLayout";
import ContactAdmin from "../components/Layout/ContactAdmin";
import Dashboard from "../components/Dashboard/Dashboard";
import CampaignWizard from "../components/Campaign/CampaignWizard";
import { useAuth } from "react-oidc-context";
import {is_user_in_user_group} from "../services/SessionTools";

function Router() {
  const auth = useAuth();
  let is_user_in_group_flag = is_user_in_user_group(auth.user);

  return (
      <Routes>
        <Route path="/" element={
          <MainLayout>
            {is_user_in_group_flag ?
              <CampaignWizard /> : <ContactAdmin />
            }
          </MainLayout>
        } />

        <Route path="/dashboard" element={
          <MainLayout>
            {is_user_in_group_flag ?
              <Dashboard /> : <span>Test</span>
            }
          </MainLayout>
        } />
        <Route path="/loginCallback" element={
          <MainLayout>
            <Empty />
          </MainLayout>
        } />
      </Routes>
  );
}

export default Router;
